import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
function NewReleasesOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 13h-2V7h2v6zM13 17h-2v-2h2v2z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.685 17.315l.85 3.584 3.67-.3L12 23l2.794-2.4 3.672.3.85-3.585 3.146-1.916L21.042 12l1.42-3.4-3.147-1.915-.85-3.584-3.67.3L12 1 9.206 3.4l-3.672-.3-.85 3.585-3.146 1.916L2.958 12l-1.42 3.4 3.147 1.915zm5.824 1.767l-1.466-.476-1.959.16-.453-1.912-.906-1.248-1.679-1.022.757-1.813v-1.542l-.757-1.813 1.679-1.022.906-1.248.453-1.912 1.96.16 1.465-.476L12 3.637l1.49 1.28 1.467.477 1.959-.16.453 1.912.906 1.248 1.679 1.022-.758 1.813v1.542l.758 1.813-1.679 1.022-.906 1.248-.453 1.912-1.96-.16-1.465.476L12 20.363l-1.49-1.28z",
    fill: "current"
  }));
}
export default NewReleasesOutlineIcon;